<script setup>
defineEmits(['move']);
</script>

<template>
  <div class="duplicate-resume-container">
    <div class="text-container">
      <span>{{ $t('popUp.duplicateResume.duplicateChoiceText') }}</span>
      <div>
        <span class="title">{{ $t('popUp.duplicateResume.duplicateSameProfile') }}</span> :
        {{ $t('popUp.duplicateResume.duplicateSameProfileText') }}
      </div>
      <div>
        <span class="title">{{ $t('popUp.duplicateResume.duplicateOtherProfile') }}</span> :
        {{ $t('popUp.duplicateResume.duplicateOtherProfileText') }}
      </div>
    </div>

    <div class="button-container">
      <div class="main-button button-cancel" @click="$emit('move', false)">
        <div class="text">{{ $t('popUp.duplicateResume.duplicateSameProfile') }}</div>
      </div>
      <div class="main-button button-create" @click="$emit('move', true)">
        <div class="text">{{ $t('popUp.duplicateResume.duplicateOtherProfile') }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.duplicate-resume-container {
  display: flex;
  flex-direction: column;
  max-width: 552px;
  gap: 2rem;

  .text-container {
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-size: 1rem;
    font-family: 'Lato', sans-serif;

    .title {
      font-weight: bold;
    }
  }

  .button-container {
    display: flex;
    width: 100%;
    gap: 1.4rem;
    justify-content: center;

    > .main-button {
      margin: 0;
      width: fit-content;
      padding: 0 1.2rem;
      font-size: 11px;
    }
  }
}
</style>
